import { useUserContext } from "@/context/UserContext";
import useGalleries from "@/hooks/useGalleries";
import { GalleryI } from "@/interfaces/galleries/Galleries";
import { readOnlyMessage, suspendedMessage } from "@/utils/DefaultMessages";
import { notifyError, notifySuccess } from "@/utils/NotificationFunctions";
import { useRouter } from "next/navigation";
import { useState } from "react";

interface withSubscribePropsI {
  gallery: GalleryI;
}

const withSubscribe = (Component: React.ComponentType<any>) => {
  return (props: withSubscribePropsI) => {
    const { gallery } = props;
    const { currentUser } = useUserContext();
    const router = useRouter();
    const [loadingSub, setLoadingSub] = useState(false);
    const { subscribeToGallery } = useGalleries();

    const subToGallery = () => {
      if (gallery && currentUser) {
        if (currentUser.isSuspended) {
          notifyError(
            suspendedMessage(
              currentUser.suspendedEndDate,
              currentUser.suspendedReason
            )
          );
        } else if (currentUser.readOnly) {
          notifyError(
            readOnlyMessage(
              currentUser.readOnlyEndDate,
              currentUser.readOnlyReason
            )
          );
        } else {
          setLoadingSub(true);
          subscribeToGallery(gallery._id).then((res: any) => {
            if (res.status === "Success") {
              notifySuccess(
                `You are now ${
                  res.data.subscriptor.includes(currentUser._id)
                    ? "subscribed to"
                    : "unsubscribed from"
                }  ` + gallery.name
              );
              router.refresh();
            } else {
              notifyError("An error has ocurred, try again later.");
              setLoadingSub(false);
            }
          });
        }
      }
    };

    return (
      <Component
        gallery={gallery}
        subToGallery={subToGallery}
        loadingSub={loadingSub}
      />
    );
  };
};

export default withSubscribe;
